/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbConfigBaseRequest extends models.ServiceNowCmdbScopeDetails {
    getFixupPrototypeFunction() { return ServiceNowCmdbConfigBaseRequest.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbConfigBaseRequest>): ServiceNowCmdbConfigBaseRequest {
        let obj = Object.assign(new ServiceNowCmdbConfigBaseRequest(), model);
        ServiceNowCmdbConfigBaseRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbConfigBaseRequest>): ServiceNowCmdbConfigBaseRequest {
        if (!model) return null;
        return ServiceNowCmdbConfigBaseRequest.newInstance(<ServiceNowCmdbConfigBaseRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbConfigBaseRequest) {
        if (!obj) return;

        models.ServiceNowCmdbConfigBaseRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbConfigBaseRequest): boolean {
        if (models.ServiceNowCmdbScopeDetails.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceNowCmdbConfigBaseRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
